/* eslint-disable prefer-destructuring */
/* eslint-disable radix */

import FilterToggleHtml from './rfct/html/filter-toggle-html';
import PaginationHtml from './rfct/html/pagination-html';
import ProductCardHtml from './rfct/html/product-card-html';
import ProductCartButtonHtml from './rfct/html/product-cart-button-html';
import SelectHtml from './rfct/html/select-html';
import jQuery3 from './rfct/jQuery/jQuery';
import moduleRegistry from './rfct/module-registry/module-registry';

// eslint-disable-next-line no-undef
let $globalConfig;
if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0 || $('#basket-form')) {
    // eslint-disable-next-line no-undef
    $globalConfig = config;
}

// adding label for basket ammount
if ($('#basket-form')) {
    if ($('#basket-form').find('input.ks-input-amount') && $globalConfig.textResources) {
        $('#basket-form').find('input.ks-input-amount').attr('aria-label', $globalConfig.textResources.productCatalogConnectorConfig.amount);
    }
}

const searchConfig = {
    selectors: {
        resultList: '.search-results__products',
        resultPagination: '.search-results__pagination',
        resultNavigation: '#search-results__navigation',
        resultPaginationTop: '#search-results__pagination-top',
        resultPaginationBottom: '#search-results__pagination-bottom',
        lightbox: '.single-lightbox',
        searchResultGrid: '.rfct-search-results__grid',
        searchResultGridItemResult: '.rfct-search-results__grid-item--results',
        searchResultGridItemMeta: '.rfct-search-results__grid-item--meta',
        filterContainer: '#rfct-search-filter-container',
        rfctSearchResults: '.rfct-search-results',
    },
};

const breadcrumb = jQuery('#dinamic-category-breadcrumb-content');
const dataIds = breadcrumb.attr('data-nav-id') || '';
const dataIdsList = dataIds !== '' ? dataIds.split('#') : [];
const $catalogID = dataIdsList[2] || '';

const $params = new URLSearchParams(window.location.search);
// eslint-disable-next-line no-restricted-globals
const $category = !isNaN($params.get('cat')) ? $params.get('cat') : dataIdsList[1] || '';
const $contextCategory = $params.get('contextCategory') || '';
const $contextCategoryArray = $contextCategory.split(',');
const $properties = $params.getAll('property') || '';
const $rangeproperties = $params.getAll('rangeproperty') || '';
const $query = $params.get('q') || '';
const $subProcedure = $params.get('sp') || '';
const $subCategory = $params.get('sc') || '';
const $procedureType = $params.get('pt') || '';
const $dataSubprocedureArray = $subProcedure.split(',');
const $dataSubcategoryArray = $subCategory.split(',');
const $dataIndicationTypeArray = $procedureType.split(';');
const $start = $params.get('start') || '0';
const $rows = $params.get('rows') || '25';
// eslint-disable-next-line no-undef
const myLazyLoad = new LazyLoad();

let $type = '';
let $apiURLparam = '';
let $queryData = '';
let hasActiveFilter = false;

const $productFilters = {
    indicationFilters: [],
    categoryFilters: [],
    catalogFilters: [],
    propertyFilters: [],
    indicationFilterTypes: [],
    selectedProperties: '',
    selectedRangeProperties: '',
    contextCategoryFilters: [],
};

const $mainFilters = {
    categories: [],
    procedures: [],
    catalogs: [],
};

function init() {
    // adding aria label to emptyx buttons
    if (($('#rfct-search-input-button-group') || $('.catalog__search')) && $globalConfig.textResources) {
        $('#rfct-search-input-button-group').find('.rfct-button').attr('aria-label', $globalConfig.textResources.productCatalogConnectorConfig.labelSearch);
        $('.catalog__search').find('.rfct-button').attr('aria-label', $globalConfig.textResources.productCatalogConnectorConfig.labelSearch);
    }
    // if there is search result container load catalog to get the type of category
    if ($(searchConfig.selectors.rfctSearchResults).length > 0) {
        // console.log(window.history.length);
        if (window.history.length < 2) {
            $('.rfct-search-results__back-link').hide();
        }
        loadCategory();
    }
}

// get type and/or create main filters
function loadCategory() {
    const apiURL = `${$globalConfig.urls.getRecursiveCategories}?category=${$category}`;

    jQuery.ajax({
        type: 'GET',
        url: apiURL,
        processData: false,
        dataType: 'json',
        success(data) {
            // get category type
            $type = data.categoryType;
            // create main filters if category is ca or d
            if (data.categoryType && data.categoryType === 'd') {
                if (data.hasChildren) {
                    $mainFilters.catalogs = data.children;
                }
                processQueryData();
            } else if (data.categoryType && data.categoryType === 'ca' && data.hasChildren) {
                data.children.forEach((mainChild) => {
                    if (mainChild.hasChildren) {
                        if (mainChild.categoryType === 'p') {
                            $mainFilters.procedures.push(mainChild);
                        } else if (mainChild.categoryType === 'c') {
                            $mainFilters.categories.push(mainChild);
                        }
                    }
                });
                processQueryData();
            } else {
                const catalogApiURL = `${$globalConfig.urls.getRecursiveCategories}?category=${$catalogID}`;

                jQuery.ajax({
                    type: 'GET',
                    url: catalogApiURL,
                    processData: false,
                    dataType: 'json',
                    success(catalogData) {
                        if (catalogData.hasChildren) {
                            catalogData.children.forEach((mainChild) => {
                                if (mainChild.hasChildren) {
                                    if (mainChild.categoryType === 'p') {
                                        $mainFilters.procedures.push(mainChild);
                                    } else if (mainChild.categoryType === 'c') {
                                        $mainFilters.categories.push(mainChild);
                                    }
                                }
                            });
                            processQueryData();
                        } else {
                            processQueryData();
                        }
                    },
                    // eslint-disable-next-line no-unused-vars
                    error(status) {
                        // eslint-disable-next-line no-console
                        // console.log('Error geting catalog main filters', status);
                        processQueryData();
                    },
                });
            }
        },
        // eslint-disable-next-line no-unused-vars
        error(status) {
            // eslint-disable-next-line no-console
            // console.log('Error geting category main filters', status);
            processQueryData();
        },
    });
}

function processQueryData() {
    let $tempProperties = '';
    let $tempSubcategoryQuery = '';
    let $tempSubprocedureQuery = '';
    $queryData += '{ "params": {';
    let $newString = '';
    let $spellcheck = '';

    // if available properties
    if ($properties && $properties.length > 0) {
        hasActiveFilter = true;

        $properties.forEach((property) => {
            if (property !== '') {
                $productFilters.selectedProperties += `${decodeURIComponent(property)};`;
                const dataPropertyValueList = decodeURIComponent(property).replace(`${decodeURIComponent(property).split(':')[0]}:`, '').split('-OR-');
                $tempProperties += `,"{!tag=${decodeURIComponent(property).split(':')[0]}}${decodeURIComponent(property).split(':')[0]}:(`;
                dataPropertyValueList.forEach((dataPeopertyValue, index) => {
                    // eslint-disable-next-line no-useless-escape
                    $tempProperties += index !== 0 ? ` OR \\"${dataPeopertyValue.replace(/\"/g, '\\\\\\\"')}\\"` : `\\"${dataPeopertyValue.replace(/\"/g, '\\\\\\\"')}\\"`;
                });
                $tempProperties += ')"';
            }
        });
    }
    // if available range properties
    if ($rangeproperties && $rangeproperties.length > 0) {
        hasActiveFilter = true;

        $rangeproperties.forEach((rangeProperty) => {
            if (rangeProperty !== '') {
                $productFilters.selectedRangeProperties += `${decodeURIComponent(rangeProperty)};`;

                const rangePropertyValue = rangeProperty.replace(`${rangeProperty.split(':')[0]}:`, '');
                $tempProperties += rangePropertyValue !== '' ? `,"{!tag=${rangeProperty.split(':')[0]}}${rangeProperty.split(':')[0]}:[${rangeProperty.split(':')[1].replace('-TO-', ' TO ')}]"` : '';
            }
        });
    }
    // if query available
    if ($query && $query !== '') {
        const string = decodeURIComponent(jQuery.urlParam('q'));
        // eslint-disable-next-line no-useless-escape
        const decodedString = string.replace(/\+/g, ' ').replace(/\"/g, '');
        // eslint-disable-next-line no-const-assign
        // eslint-disable-next-line no-undef
        for (let i = 0; i < decodedString.length; i++) {
            // eslint-disable-next-line no-undef
            const c = decodedString.charAt(i);
            // These characters are part of the query syntax and must be escaped
            // eslint-disable-next-line eqeqeq
            // eslint-disable-next-line no-useless-escape
            if (c === '\\' || c === '+' || c === '-' || c === '!' || c === '(' || c === ')' || c === ':' || c === '^' || c === '[' || c === ']' || c === '{' || c === '}' || c === '~' || c === '*' || c === '?' || c === '|' || c === '&' || c === ';' || c === '/' || c === ' ') {
                $newString += `\\\\${c}`;

                if(c === ' ') {
                    $spellcheck += `${c}`;
                } else {
                    $spellcheck += `\\\\${c}`;
                }
            // eslint-disable-next-line no-useless-escape
            } else if (c === '"') {
                // eslint-disable-next-line prefer-template
                $newString += '\\' + c;
                $spellcheck += '\\' + c;
            } else {
                $newString += c;
                $spellcheck += c;
            }
        }
    }

    let sortField = '';

    if ($type === 'c' || $type === 'p') {
        sortField = `sortOrderForCategory_${$category}_i`;
    } else {
        sortField = $type === 'ca' ? `sortOrderForCategory_${$category}_i` : `sortOrderForCategory_${$category}_i`;
    }

    $queryData += $newString !== '' ? `"q":"${$newString}* OR ${$newString}",` : `"q":"*","sort":"${sortField} ASC",`;
    $queryData += ($start && $start !== '') ? `"start":${$start},` : '"start":0,';
    $queryData += ($rows && $rows !== '') ? `"rows":${$rows},` : '"rows":25,';

    if ($subCategory && $subCategory !== '') {
        hasActiveFilter = true;
        $dataSubcategoryArray.forEach((dataSubcategoryItem) => {
            $tempSubcategoryQuery += (dataSubcategoryItem !== '') ? `,"indication_tax_ids:*${dataSubcategoryItem}*"` : '';
        });
    }

    if ($subProcedure && $subProcedure !== '') {
        hasActiveFilter = true;
        $dataSubprocedureArray.forEach((dataSubprocedureItem) => {
            $tempSubprocedureQuery += (dataSubprocedureItem !== '') ? `,"product_categories_tax_ids:*${dataSubprocedureItem}*"` : '';
        });
    }

    if ($procedureType && $procedureType !== '') {
        hasActiveFilter = true;
        $dataIndicationTypeArray.forEach((dataIndicationTypeItem) => {
            $tempSubprocedureQuery += (dataIndicationTypeItem !== '') ? `,"indication_tax_types:${dataIndicationTypeItem}"` : '';
        });
    }

    if ($contextCategory && $contextCategory !== '') {
        hasActiveFilter = true;
        $contextCategoryArray.forEach((contextCategoryItem) => {
            $tempSubcategoryQuery += (contextCategoryItem !== '') ? `,"ContextCategoryProperty_ss:\\"${contextCategoryItem}\\""` : '';
            $tempSubprocedureQuery += (contextCategoryItem !== '') ? `,"ContextCategoryProperty_ss:\\"${contextCategoryItem}\\""` : '';
        });
    }

    if ($type === 'c' || $type === 'p') {
        $queryData += $type === 'c' ? `"fq":["content_type_s:product","product_categories_tax_ids:*${$category}*"${$tempSubcategoryQuery}${$tempProperties}],` : `"fq":["content_type_s:product","indication_tax_ids:*${$category}*"${$tempSubprocedureQuery}${$tempProperties}],`;
        $queryData += '"facet.field": [';
        $productFilters.propertyFilters.forEach((propertyFilter, index) => {
            $queryData += `"{!ex=${propertyFilter.id}}${propertyFilter.id}`;
            $queryData += (($productFilters.propertyFilters.length - 1) !== index) ? '",' : '"';
        });
        $queryData += '],';
    } else {
        $queryData += $type === 'ca' ? `"fq":["main_categories_tax_ids:*${$category}*"],` : `"fq":["content_type_s:product","division_s:${$category}"],`;
    }

    $queryData += '"facet.pivot": ["extendedProperties_ss", "product_categories_tax_names", "indication_tax_names", "indication_tax_types", "product_categories_tax_ids", "indication_tax_ids", "main_categories_tax_ids", "ContextCategoryProperty_ss", "extendedProperties_ss"],';

    $queryData += '"fl": ["teaserImageAlternateName_s", "product_categories_tax_ids", "identifier", "document_references", "productID", "abstract", "name", "TipTextForDetailsAndBasket_s"],';

    $queryData += ($query && $query !== '') ? `"spellcheck.q":"${$spellcheck}",` : '"spellcheck.q":"",';

    $queryData += '"spellcheck.dictionary": "spellchecker_in_textSpellCheckComponentForQuery","spellcheck":"on", "spellcheck.collate":"true", "spellcheck.maxCollations": 10,';

    $queryData += '"wt": "json", "facet.pivot.mincount": 1, "facet": "on" }}';

    createAPIurl();

    if ($(searchConfig.selectors.lightbox).length > 0) {
        initLightbox(jQuery(searchConfig.selectors.lightbox));
    }
}

function initLightbox($lightbox) {
    $lightbox.imageLightbox({
        button: true,
        overlay: true,
        animationSpeed: 250,
        quitOnImgClick: true,
        caption: true,
    });

    // initializeLightboxes();
}

// get URL params and create global URL
function createAPIurl() {
    $apiURLparam += $query && $query !== '' ? `?q=${$query}` : '?q=';
    if ($category && $category !== '') {
        $apiURLparam += `&cat=${$category}`;
        if ($type && $type === 'p') {
            $apiURLparam += '&t=p';
            $apiURLparam += $subProcedure && $subProcedure !== '' ? `&sp=${$subProcedure}` : '';
        } else if ($type && $type === 'c') {
            $apiURLparam += '&t=c';
            $apiURLparam += $subCategory && $subCategory !== '' ? `&sc=${$subCategory}` : '';
        } else {
            $apiURLparam += `&t=${$type}`;
        }
    }
    $apiURLparam += ($rows && $rows !== '') ? `&rows=${$rows}` : '';
    loadSearchFacets();
}

// load product filters
function loadSearchFacets() {
    $.ajax({
        contentType: 'text/json',
        url: $globalConfig.urls.getProductResults,
        data: $queryData,
        type: 'POST',
        dataType: 'json',
        success(data) {
            if (data.facet_counts.facet_pivot.extendedProperties_ss.length > 0) {
                // eslint-disable-next-line max-len
                data.facet_counts.facet_pivot.extendedProperties_ss.forEach((filterPropertyFacet) => {
                    const filterNameArray = filterPropertyFacet.value.split('#');
                    const newFilter = {
                        name: filterNameArray[1],
                        count: filterPropertyFacet.count,
                        id: filterNameArray[0],
                        values: [],
                        unit: filterNameArray.length > 3 ? filterNameArray[3] : '',
                    };
                    $productFilters.propertyFilters.push(newFilter);
                });
            }
            $(searchConfig.selectors.rfctSearchResults).each((i, el) => {
                const $searchResultList = $(el);
                initResults($searchResultList);
            });
        },
        // eslint-disable-next-line no-unused-vars
        error(status) {
            // eslint-disable-next-line no-console
            // console.log('Error getting product filters', status);
            $(searchConfig.selectors.rfctSearchResults).each((i, el) => {
                const $searchResultList = $(el);
                initResults($searchResultList);
            });
        },
    });
}

// get results
function initResults($rfctSearchResults) {
    let $tempProperties = '';
    let $tempSubcategoryQuery = '';
    let $tempSubprocedureQuery = '';
    $queryData = '';
    $queryData += '{ "params": {';
    let $newString = '';
    let $spellcheck = '';

    // if available properties
    if ($properties && $properties.length > 0) {
        $properties.forEach((property) => {
            if (property !== '') {
                $productFilters.selectedProperties += `${decodeURIComponent(property)};`;
                const dataPropertyValueList = decodeURIComponent(property).replace(`${decodeURIComponent(property).split(':')[0]}:`, '').split('-OR-');
                $tempProperties += `,"{!tag=${decodeURIComponent(property).split(':')[0]}}${decodeURIComponent(property).split(':')[0]}:(`;
                dataPropertyValueList.forEach((dataPeopertyValue, index) => {
                    // eslint-disable-next-line no-useless-escape
                    $tempProperties += index !== 0 ? ` OR \\"${dataPeopertyValue.replace(/\"/g, '\\\\\\\"')}\\"` : `\\"${dataPeopertyValue.replace(/\"/g, '\\\\\\\"')}\\"`;
                });
                $tempProperties += ')"';
            }
        });
    }
    // if available range properties
    if ($rangeproperties && $rangeproperties.length > 0) {
        $rangeproperties.forEach((rangeProperty) => {
            if (rangeProperty !== '') {
                $productFilters.selectedRangeProperties += `${decodeURIComponent(rangeProperty)};`;

                const rangePropertyValue = rangeProperty.replace(`${rangeProperty.split(':')[0]}:`, '');
                $tempProperties += rangePropertyValue !== '' ? `,"{!tag=${rangeProperty.split(':')[0]}}${rangeProperty.split(':')[0]}:[${rangeProperty.split(':')[1].replace('-TO-', ' TO ')}]"` : '';
            }
        });
    }
    // if query available
    if ($query && $query !== '') {
        const string = decodeURIComponent(jQuery.urlParam('q'));
        // eslint-disable-next-line no-useless-escape
        const decodedString = string.replace(/\+/g, ' ').replace(/\"/g, '');
        // eslint-disable-next-line no-const-assign
        // eslint-disable-next-line no-undef
        for (let i = 0; i < decodedString.length; i++) {
            // eslint-disable-next-line no-undef
            const c = decodedString.charAt(i);
            // These characters are part of the query syntax and must be escaped
            // eslint-disable-next-line eqeqeq
            // eslint-disable-next-line no-useless-escape
            if (c === '\\' || c === '+' || c === '-' || c === '!' || c === '(' || c === ')' || c === ':' || c === '^' || c === '[' || c === ']' || c === '{' || c === '}' || c === '~' || c === '*' || c === '?' || c === '|' || c === '&' || c === ';' || c === '/' || c === ' ') {
                $newString += `\\\\${c}`;

                if(c === ' ') {
                    $spellcheck += `${c}`;
                } else {
                    $spellcheck += `\\\\${c}`;
                }
            // eslint-disable-next-line no-useless-escape
            } else if (c === '"') {
                // eslint-disable-next-line prefer-template
                $newString += '\\' + c;
                $spellcheck += '\\' + c;
            } else {
                $newString += c;
                $spellcheck += c;
            }
        }
    }

    let sortField = '';

    if ($type === 'c' || $type === 'p') {
        sortField = `sortOrderForCategory_${$category}_i`;
    } else {
        sortField = $type === 'ca' ? `sortOrderForCategory_${$category}_i` : `sortOrderForCategory_${$category}_i`;
    }

    $queryData += $newString !== '' ? `"q":"${$newString}* OR ${$newString}",` : `"q":"*","sort":"${sortField} ASC",`;
    $queryData += ($start && $start !== '') ? `"start":${$start},` : '"start":0,';
    $queryData += ($rows && $rows !== '') ? `"rows":${$rows},` : '"rows":25,';

    if ($subCategory && $subCategory !== '') {
        $dataSubcategoryArray.forEach((dataSubcategoryItem) => {
            $tempSubcategoryQuery += (dataSubcategoryItem !== '') ? `,"indication_tax_ids:*${dataSubcategoryItem}*"` : '';
        });
    }

    if ($subProcedure && $subProcedure !== '') {
        $dataSubprocedureArray.forEach((dataSubprocedureItem) => {
            $tempSubprocedureQuery += (dataSubprocedureItem !== '') ? `,"product_categories_tax_ids:*${dataSubprocedureItem}*"` : '';
        });
    }

    if ($procedureType && $procedureType !== '') {
        $dataIndicationTypeArray.forEach((dataIndicationTypeItem) => {
            $tempSubprocedureQuery += (dataIndicationTypeItem !== '') ? `,"indication_tax_types:${dataIndicationTypeItem}"` : '';
        });
    }

    if ($contextCategory && $contextCategory !== '') {
        $contextCategoryArray.forEach((contextCategoryItem) => {
            $tempSubcategoryQuery += (contextCategoryItem !== '') ? `,"ContextCategoryProperty_ss:\\"${contextCategoryItem}\\""` : '';
            $tempSubprocedureQuery += (contextCategoryItem !== '') ? `,"ContextCategoryProperty_ss:\\"${contextCategoryItem}\\""` : '';
        });
    }

    if ($type === 'c' || $type === 'p') {
        $queryData += $type === 'c' ? `"fq":["content_type_s:product","product_categories_tax_ids:*${$category}*"${$tempSubcategoryQuery}${$tempProperties}],` : `"fq":["content_type_s:product","indication_tax_ids:*${$category}*"${$tempSubprocedureQuery}${$tempProperties}],`;
        $queryData += '"facet.field": [';
        $productFilters.propertyFilters.forEach((propertyFilter, index) => {
            $queryData += `"{!ex=${propertyFilter.id}}${propertyFilter.id}`;
            $queryData += (($productFilters.propertyFilters.length - 1) !== index) ? '",' : '"';
        });
        $queryData += '],';
    } else {
        $queryData += $type === 'ca' ? `"fq":["main_categories_tax_ids:*${$category}*"],` : `"fq":["content_type_s:product","division_s:${$category}"],`;
    }

    $queryData += '"facet.pivot": ["extendedProperties_ss", "product_categories_tax_names", "indication_tax_names", "indication_tax_types", "product_categories_tax_ids", "indication_tax_ids", "main_categories_tax_ids", "ContextCategoryProperty_ss", "extendedProperties_ss"],';

    $queryData += '"fl": ["teaserImageAlternateName_s", "product_categories_tax_ids", "identifier", "document_references", "productID", "abstract", "name", "TipTextForDetailsAndBasket_s"],';

    $queryData += ($query && $query !== '') ? `"spellcheck.q":"${$spellcheck}",` : '"spellcheck.q":"",';

    $queryData += '"spellcheck.dictionary": "spellchecker_in_textSpellCheckComponentForQuery","spellcheck":"on", "spellcheck.collate":"true", "spellcheck.maxCollations": 10,';

    $queryData += '"wt": "json", "facet.pivot.mincount": 1, "facet": "on" }}';

    $.ajax({
        contentType: 'text/json',
        url: $globalConfig.urls.getProductResults,
        data: $queryData,
        type: 'POST',
        dataType: 'json',
        success(data) {
            createSearchResults($rfctSearchResults, data);
        },
        // eslint-disable-next-line no-unused-vars
        error(status) {
            // eslint-disable-next-line no-console
            // console.log('Error getting products', status);
            $rfctSearchResults.append('<div> Error Message </div>');
        },
    });
}

// create product cards
function createSearchResults($rfctSearchResults, solrData) {
    if (typeof _etracker === 'object' && $query && $start === '0') {
        const filterResults = hasActiveFilter ? ' [filter]' : '';
        const ccAttributes = {
            etcc_cu: 'onsite',
            etcc_med_onsite: 'Search-OnlineCatalog',
            etcc_cmp_onsite: `${solrData.response.numFound} Results${filterResults}`,
            etcc_st_onsite: $query,
        };

        // eslint-disable-next-line no-undef
        et_eC_Wrapper({
            et_et: '86mOu9',
            cc_attributes: ccAttributes,
        });
    }

    const searchResults = solrData.response;
    // let additionalProducts = '';
    const $searchResultGrid = $rfctSearchResults.find(searchConfig.selectors.searchResultGrid);
    const $searchResultGridItemResult = $searchResultGrid
        .find(searchConfig.selectors.searchResultGridItemResult);
    const $searchResultGridItemMeta = $searchResultGrid
        .find(searchConfig.selectors.searchResultGridItemMeta);
    const $filterContainer = $(searchConfig.selectors.filterContainer);

    if (searchResults && searchResults.numFound > 0) {
        const currentPage = Math.floor((parseInt($start) / parseInt($rows)) + 1);
        const maxPages = Math.ceil(parseInt(searchResults.numFound) / parseInt($rows));

        createFacets(solrData);

        const paginationLabelTemplate = `${$globalConfig.textResources.productCatalogConnectorConfig.labelPage} {CURRENT_PAGE} ${$globalConfig.textResources.productCatalogConnectorConfig.labelOf} {PAGE_COUNT}`;

        const paginationLinkCallback = (pageIndex) => {
            const resultPerPage = $rows || 25;
            const defaultStart = `&start=${$start}`;
            const newStartValue = `&start=${pageIndex * resultPerPage}`;
            const href = `?${window.location.search.substring(1).replace(defaultStart, '')}${newStartValue}`;
            return href;
        };

        const filterContainerHtml = createFilterContainerHtml(solrData);
        const metaGridItemHtml = createMetaGridItemHtml(
            searchResults.numFound,
            currentPage - 1,
            maxPages,
            paginationLabelTemplate,
            paginationLinkCallback,
        );
        const resultGridItemHtml = createResultGridItemHtml(searchResults);
        const paginationGridItemHtml = createPaginationGridItemHtml(
            currentPage - 1,
            maxPages,
            paginationLabelTemplate,
            paginationLinkCallback,
        );

        // insert filters
        moduleRegistry.insertHTML($filterContainer, filterContainerHtml);

        // insert results
        moduleRegistry.insertHTML($searchResultGridItemResult, resultGridItemHtml);

        // insert meta content
        moduleRegistry.insertHTML($searchResultGridItemMeta, metaGridItemHtml, {
            selectorCallbacks: {
                // Results Per Page Select
                '.rfct-search-results__results-per-page-container select.rfct-select__select': (el) => {
                    const $select = jQuery3(el);
                    $select.on('change', () => {
                        const defaultRows = `&rows=${$rows}`;
                        const newRowsValue = `&rows=${$select.val()}`;
                        if (defaultRows !== newRowsValue) {
                            window.location.href = `?${window.location.search.substring(1).replace(/&start=\d+/, '&start=0').replace(defaultRows, '')}${newRowsValue}`;
                        }
                    });
                },
            },
        });

        // insert pagination
        moduleRegistry.insertHTML(
            $searchResultGridItemResult,
            paginationGridItemHtml,
            {
                append: true,
            },
        );

        myLazyLoad.update();
        // eslint-disable-next-line no-undef
        picturefill();
        $('[data-toggle="tooltip"]').tooltip();

        initFacetEventHandlers();
    } else {
        $searchResultGridItemMeta.remove();

        const buttonUrl = `${window.location.origin + window.location.pathname}?cat=${$category}`;
        let resultGridItemHtml;

        if (solrData.spellcheck) {
            if (solrData.spellcheck.collations.length > 1) {
                resultGridItemHtml = createResultErrorGridItemHtml(
                    `<div class="rfct-info-box">
                        <span class="rfct-info-box__icon material-icons">error_outline</span>
                        <div class="rfct-info-box__text">
                            <p>${$globalConfig.textResources.productCatalogConnectorConfig.noProductsMessage}<br/> ${$globalConfig.textResources.productCatalogConnectorConfig.didYouMeanMessage}: <a href="${buttonUrl}&q=${solrData.spellcheck.collations[1]}"><b>${decodeURIComponent(solrData.spellcheck.collations[1].replace(/\+/g, ' '))}</b><a>?</p>
                        </div>
                    </div>`,
                );
                create404Html();
            } else {
                resultGridItemHtml = createResultErrorGridItemHtml(
                    `<div class="rfct-info-box">
                        <span class="rfct-info-box__icon material-icons">error_outline</span>
                        <div class="rfct-info-box__text">
                            <p>${$globalConfig.textResources.productCatalogConnectorConfig.noProductsMessage}</p>
                        </div>
                    </div>`,
                );
                create404Html();
            }
        } else {
            resultGridItemHtml = createResultErrorGridItemHtml(
                `<div>${$globalConfig.textResources.productCatalogConnectorConfig.noProductsMessage}</div>`,
            );
            create404Html();
        }

        // insert filters
        moduleRegistry.insertHTML($searchResultGridItemResult, resultGridItemHtml);

        $(searchConfig.selectors.resultNavigation).append(`<a class="search-results__navigation-filter" role="button" href="${buttonUrl}"><h3 class="mdc-list-group__subheader search-results__navigation-header">${$globalConfig.textResources.productCatalogConnectorConfig.labelResetFilter}</h3></a>`);
        myLazyLoad.update();
        // eslint-disable-next-line no-undef
        picturefill();
        $('[data-toggle="tooltip"]').tooltip();
        createFacets(solrData);
    }
}

function createResultGridItemHtml(searchResults) {
    let html = `
        <div class="rfct-search-results__result-count-container">
            <strong class="rfct-search-results__result-count">
                ${searchResults.numFound} ${$globalConfig.textResources.productCatalogConnectorConfig.labelProducts}
            </strong>
        </div>
        <div class="rfct-search-results__result-container">
            <div class="rfct-search-results__result">
                <ul class="rfct-search-results__result-list">`;
    searchResults.docs.forEach((product) => {
        html += '<li class="rfct-search-results__result-item">';

        const productURL = `${$globalConfig.urls.productDetailPageHtml}?productID=${product.identifier}&cat=${$category}`;

        let pictureXS = $globalConfig.images.cardPictureXS;
        // eslint-disable-next-line no-unused-vars
        let pictureMD = $globalConfig.images.cardPictureMD;
        // eslint-disable-next-line no-unused-vars
        let pictureXL = $globalConfig.images.cardPictureXL;
        let imageExist = false;
        let imageAlt = '';
        // eslint-disable-next-line no-unused-vars
        let mainImageID = '';

        if (product.document_references && product.document_references !== '') {
            product.document_references.forEach((productImage) => {
                mainImageID = productImage.split('#')[0].replace('PIC_PROD_MAIN_', '');
                imageExist = true;
                imageAlt = product.teaserImageAlternateName_s ? product.teaserImageAlternateName_s : '';
                if (productImage.includes('#WEBXL')) {
                    // eslint-disable-next-line prefer-destructuring
                    pictureXL = productImage.split('#')[2];
                }
                if (productImage.includes('#WEBMD')) {
                    // eslint-disable-next-line prefer-destructuring
                    pictureMD = productImage.split('#')[2];
                }
                if (productImage.includes('#WEBXS')) {
                    // eslint-disable-next-line prefer-destructuring
                    pictureXS = productImage.split('#')[2];
                }
            });
        }

        const data = [];

        if (product.abstract && product.abstract !== '') {
            const productApstractList = product.abstract.split(';');
            let i = 0;
            productApstractList.forEach((productAbstractValue) => {
                if (productAbstractValue !== '' && i < 5) {
                    const productAbstractValueList = productAbstractValue.split('#');
                    if (productAbstractValueList.length > 2) {
                        data.push({
                            key: productAbstractValueList[0],
                            value: decodeURIComponent(productAbstractValueList[1]),
                            additionalValue: decodeURIComponent(productAbstractValueList[2]),
                        });
                    } else {
                        data.push({
                            key: productAbstractValueList[0],
                            value: decodeURIComponent(productAbstractValueList[1]),
                        });
                    }
                    i++;
                }
            });
        }

        const image = imageExist ? {
            // eslint-disable-next-line max-len
            identifier: true, WEBXS: pictureXS, WEBMD: pictureXS, WEBLG: pictureXS, alternateName: imageAlt,
        } : { WEBXS: pictureXS, WEBMD: pictureXS, WEBLG: pictureXS };

        // eslint-disable-next-line max-len
        const productCartButton = new ProductCartButtonHtml(product.identifier, product.productID, product.name, 'Catalog Search', '', image).toString();

        html += new ProductCardHtml(
            productURL,
            product.productID,
            product.name,
            data,
            image,
            productCartButton,
        );
        html += '</li>';
    });

    html += `
                </ul>
            </div>
        </div>`;

    return html;
}

function createResultErrorGridItemHtml(content) {
    const html = `
        <div class="rfct-search-results__result-container">
            <div class="rfct-search-results__error">
                ${content}
            </div>
        </div>`;
    return html;
}

function create404Html() {
    // create query URL
    const getSearchOverlayJsonUrl = `${$globalConfig.urls.getSearchOverlayJson}?q=${encodeURIComponent($query)}`;

    // const getSearchOverlayJsonUrl = `${$globalConfig.urls.getSearchOverlayJson}?q=endo`;

    // get overlay elements
    jQuery.getJSON(getSearchOverlayJsonUrl, (rowData) => {
        // console.log(rowData);
        const url = new URL(window.location.href);
        const $categoryID = url.searchParams.get('cat') || url.searchParams.get('div') || '';
        // eslint-disable-next-line no-unused-vars
        const $searchURLparam = `&cat=${$categoryID}`;
        const key = Object.keys(rowData.suggest.suggest.filteredProductNamesSuggesterDictionary)[0];
        // eslint-disable-next-line max-len
        const suggestResults = rowData.suggest.suggest.filteredProductNamesSuggesterDictionary[key].suggestions;
        const rowResults = rowData.results.grouped.content_type_s.groups;
        let productResults = [];
        let areaResults = [];

        rowResults.forEach((rowResult) => {
            if (rowResult.groupValue === 'taxonomy') {
                areaResults = rowResult.doclist.docs;
            } else if (rowResult.groupValue === 'product') {
                productResults = rowResult.doclist.docs;
            }
        });
        const suggestions = [];
        const products = [];
        const areas = [];
        // get overlay elements -> suggestions
        if (suggestResults.length > 0) {
            suggestResults.forEach((suggestion) => {
                suggestions.push(suggestion.term);
            });
        }
        // get overlay elements -> products
        if (productResults.length > 0) {
            productResults.forEach((product) => {
                let cardPictureXS = $globalConfig.images.cardPictureMD;
                let cardPictureMD = $globalConfig.images.cardPictureMD;
                let cardPictureXL = $globalConfig.images.cardPictureMD;
                let showImage = true;
                if (product.document_references) {
                    product.document_references.forEach((image) => {
                        if (image.includes('WEBXS')) {
                            cardPictureXS = $globalConfig.urls.mediaFilesURL + image.split('#')[2];
                        } else {
                            showImage = false;
                        }
                        if (image.includes('WEBSM')) {
                            cardPictureMD = $globalConfig.urls.mediaFilesURL + image.split('#')[2];
                        } else {
                            showImage = false;
                        }
                        if (image.includes('WEBMD')) {
                            cardPictureXL = $globalConfig.urls.mediaFilesURL + image.split('#')[2];
                        } else {
                            showImage = false;
                        }
                    });
                }

                let firstCat = '';
                // eslint-disable-next-line max-len
                if (product.product_categories_tax_ids && product.product_categories_tax_ids.length) {
                    const catArray = product.product_categories_tax_ids[0].split('#');
                    firstCat = catArray[catArray.length - 1];
                }

                const tempProduct = {
                    name: product.name,
                    id: product.id,
                    productID: product.productID,
                    showImage,
                    images: {
                        cardPictureXS,
                        cardPictureMD,
                        cardPictureXL,
                    },
                    teaserImageAlternateName_s: product.teaserImageAlternateName_s,
                    firstCat,
                };
                products.push(tempProduct);
            });
        }
        // get overlay elements -> areas
        if (areaResults.length > 0) {
            areaResults.forEach((area) => {
                const tempArea = {
                    name: area.name,
                    categories: area.indication_tax_names,
                    categoryIds: area.indication_tax_ids,
                    description: area.longDescription_t ? area.longDescription_t : '',
                };
                areas.push(tempArea);
            });
        }

        let searchProductsContainerData = '';

        // create overlay elements -> products
        if (products.length > 0) {
            products.forEach((product) => {
                let pictureHtml = `<div class="rfct-placeholder-image">
                    <div class="rfct-placeholder-image__ratio" style="padding-top: ${((9 / 16) * 100).toFixed(5)}%;"></div>
                   <div class="rfct-placeholder-image__small">
                            <img src="${$globalConfig.images.noImage}">
                        </div>
                </div>`;

                if (!product.showImage) {
                    pictureHtml = `<picture>
                        <source media="(min-width: 999px)" data-srcset="${product.images.cardPictureXL} 1x, ${product.images.cardPictureXL} 2x" srcset="${product.images.cardPictureXL} 1x, ${product.images.cardPictureXL} 2x">
                        <source media="(min-width: 797px)" data-srcset="${product.images.cardPictureMD} 1x, ${product.images.cardPictureMD} 2x" srcset="${product.images.cardPictureMD} 1x, ${product.images.cardPictureMD} 2x">
                        <source data-srcset="${product.images.cardPictureXS} 1x, ${product.images.cardPictureXS} 2x" srcset="${product.images.cardPictureXS} 1x, ${product.images.cardPictureXS} 2x">
                        <img data-srcset="${product.images.cardPictureXS}" data-object-fit="cover" src="${product.images.cardPictureXS}" alt="${product.teaserImageAlternateName_s}" class="lazy rfct-fallback-results__area-image" />
                    </picture>`;
                }
                searchProductsContainerData += `
                <div class="rfct-fallback-results__product">
                    <div class="rfct-fallback-results__product-image-container">
                        ${pictureHtml}
                    </div>
                    <a class="rfct-fallback-results__product-text-container" title="${product.name}" href="${$globalConfig.urls.productDetailPageHtml}?productID=${product.id}&cat=${product.firstCat}&etcc_cu=onsite&etcc_med_onsite=Search-OnlineCatalog-Overlay&etcc_cmp_onsite=Search-Overlay&etcc_st_onsite=${encodeURIComponent($query)}">
                    <h3 class="rfct-fallback-results__product-title rfct-fallback-results__searchword-value">${product.name}</h3>
                    <p class="rfct-fallback-results__product-code">${product.productID}</p>
                    </a>
                </div>`;
            });
        }
        // create overlay elements -> areas
        let html = searchProductsContainerData;
        if (areas.length > 0) {
            areas.forEach((area) => {
                let childHtml = '';
                childHtml += '<div class="rfct-fallback-results__area">';
                if (area.categories.length > 4) {
                    area.categories.forEach((category, i) => {
                        if (i === 2) {
                            childHtml += `<a href="${$globalConfig.urls.areaOfExpertiseHtml}?cat=${area.categoryIds[i]}&etcc_cu=onsite&etcc_med_onsite=Search-OnlineCatalog-Overlay&etcc_cmp_onsite=Search-Overlay&etcc_st_onsite=${encodeURIComponent($query)}" role="row" tabindex="-1">
                                ${category}
                            </a>`;
                        } else if (i > 3) {
                            if ((area.categories.length - 1) !== i) {
                                childHtml += `<a href="${$globalConfig.urls.categoryHtml}?cat=${area.categoryIds[i]}&etcc_cu=onsite&etcc_med_onsite=Search-OnlineCatalog-Overlay&etcc_cmp_onsite=Search-Overlay&etcc_st_onsite=${encodeURIComponent($query)}" role="row" tabindex="-1">
                                    ${category}
                                </a>`;
                            }
                        }
                    });
                }
                let areaTempURL = `${$globalConfig.urls.searchHtml}?cat=${area.categoryIds[area.categoryIds.length - 1]}`;
                if (area.categories.length === 3) {
                    areaTempURL = `${$globalConfig.urls.searchHtml}?cat=${area.categoryIds[2]}`;
                }
                childHtml += `
                <a class="rfct-fallback-results__area-link" title="${area.name}" href="${areaTempURL}&etcc_cu=onsite&etcc_med_onsite=Search-OnlineCatalog-Overlay&etcc_cmp_onsite=Search-Overlay&etcc_st_onsite=${encodeURIComponent($query)}">
                    <div class="rfct-fallback-results__area-inner">
                        <div class="rfct-fallback-results__area-text-container">
                            <h3 class="rfct-fallback-results__area-title rfct-fallback-results__searchword-value">${area.name}</h3>
                        </div>
                    </div></a>`;
                childHtml += '</div>';

                html += `${childHtml}`;
            });
        }

        if (areas.length > 0 || products.length > 0) {
            html = `<h2 class="mt-3 mb-2">${$globalConfig.textResources.productCatalogConnectorConfig.headlineForSearchOverlayIfNoProductsFound}</h2>${html}`;
        }

        html = `<div class="404">${html}</div>`;

        $('.rfct-search-results__result-container').append(html);

        myLazyLoad.update();
    });
}

function createMetaGridItemHtml(
    productCount,
    currentPage,
    pageCount,
    paginationLabelTemplate,
    hrefCallback,
) {
    const paginationHtmlGenerator = new PaginationHtml(
        currentPage,
        pageCount,
        paginationLabelTemplate,
        hrefCallback,
    );
    const selectOptions = [];

    ['25', '50', '100', '125'].forEach((rows) => {
        const selected = $rows === rows;

        selectOptions.push({
            value: rows,
            label: rows,
            selected,
            disabled: selected,
        });
    });

    const resultsPerPageSelectHtmlGenerator = new SelectHtml(
        null,
        null,
        selectOptions,
        {
            small: true,
            inline: true,
        },
    );
    const html = `
        <div class="rfct-search-results__meta-container">
            <div class="rfct-search-results__result-count-container">
                <strong class="rfct-search-results__result-count">
                    ${productCount} ${$globalConfig.textResources.productCatalogConnectorConfig.labelProducts}
                </strong>
            </div>
            <div class="rfct-search-results__pagination-container">
                ${paginationHtmlGenerator}
            </div>
            <div class="rfct-search-results__results-per-page-container">
                <span class="rfct-search-results__results-per-page-text">
                    ${$globalConfig.textResources.productCatalogConnectorConfig.labelNumber}
                </span>
                ${resultsPerPageSelectHtmlGenerator}
            </div>
        </div>`;
    return html;
}

function createPaginationGridItemHtml(
    currentPage,
    pageCount,
    paginationLabelTemplate,
    hrefCallback,
) {
    const paginationHtmlGenerator = new PaginationHtml(
        currentPage,
        pageCount,
        paginationLabelTemplate,
        hrefCallback,
    );

    const html = `
        <div class="rfct-search-results__grid-item rfct-search-results__grid-item--pagination">
            <div class="rfct-search-results__pagination-container">
                ${paginationHtmlGenerator}
            </div>
        </div>`;
    return html;
}

function createFilterContainerHtml(solrData) {
    const html = new FilterToggleHtml(
        $globalConfig.textResources.productCatalogConnectorConfig.filterToggleButtonText,
        $globalConfig.textResources.productCatalogConnectorConfig.filterHeadline,
        createFilterHtml(solrData),
    ).toString();
    return html;
}

function createFilterHtml(solrData) {
    const {
        searchFacetData,
        filterData,
    } = getLegacyFilterHtml(solrData);
    const html = (searchFacetData !== '' || filterData !== '') ? `
        <div class="rfct-search-results__filter-group">
            <strong class="rfct-search-results__filter-headline">${$globalConfig.textResources.productCatalogConnectorConfig.filterHeadline}</strong>
        </div>
        <div id="rfct-filters" class="rfct-search-results__filter-group-content">
            <div class="search-results__navigation">
                ${searchFacetData}${filterData}
            </div>
        </div>
    ` : '';
    return html;
}

// create facets depending on search type
function createFacets(solrData) {
    if ($type === 'c' || $type === 'ca') {
        $mainFilters.procedures.forEach((mainFilter) => {
            let validFilter = false;
            const tempMainFilter = {
                name: mainFilter.name,
                title: mainFilter.title,
                identifier: mainFilter.identifier,
                children: [],
            };
            mainFilter.children.forEach((childFilter) => {
                solrData.facet_counts.facet_pivot.indication_tax_ids.forEach((categoryFilter) => {
                    if (String(categoryFilter.value).endsWith(childFilter.identifier) && categoryFilter.value.split('#').length === 4) {
                        validFilter = true;
                        let selectedFilter = false;
                        $dataSubcategoryArray.forEach((selectedProperty) => {
                            if (selectedProperty === childFilter.identifier) {
                                selectedFilter = true;
                            }
                        });
                        const tempChildFilter = {
                            name: childFilter.name,
                            title: childFilter.title,
                            identifier: childFilter.identifier,
                            count: categoryFilter.count,
                            selected: selectedFilter,
                        };
                        tempMainFilter.children.push(tempChildFilter);
                    }
                });
            });
            if (validFilter) {
                $productFilters.indicationFilters.push(tempMainFilter);
            }
        });
    }

    if ($type === 'p' || $type === 'ca') {
        $mainFilters.categories.forEach((mainFilter) => {
            let validFilter = false;
            const tempMainFilter = {
                name: mainFilter.name,
                title: mainFilter.title,
                identifier: mainFilter.identifier,
                children: [],
            };
            mainFilter.children.forEach((childFilter) => {
                // eslint-disable-next-line max-len
                solrData.facet_counts.facet_pivot.product_categories_tax_ids.forEach((categoryFilter) => {
                    if (String(categoryFilter.value).endsWith(childFilter.identifier) && categoryFilter.value.split('#').length === 4) {
                        validFilter = true;
                        let selectedFilter = false;
                        $dataSubprocedureArray.forEach((selectedProperty) => {
                            if (selectedProperty === childFilter.identifier) {
                                selectedFilter = true;
                            }
                        });
                        const tempChildFilter = {
                            name: childFilter.name,
                            title: childFilter.title,
                            identifier: childFilter.identifier,
                            count: categoryFilter.count,
                            selected: selectedFilter,
                        };
                        tempMainFilter.children.push(tempChildFilter);
                    }
                });
            });
            if (validFilter) {
                $productFilters.categoryFilters.push(tempMainFilter);
            }
        });

        solrData.facet_counts.facet_pivot.indication_tax_types.forEach((indicationType) => {
            const indicationTypeValueList = indicationType.value.split('#');
            // eslint-disable-next-line max-len
            if (indicationTypeValueList && indicationTypeValueList.length > 1 && indicationTypeValueList[1] === $category) {
                const newFilter = {
                    name: indicationTypeValueList[0],
                    count: indicationType.count,
                    value: indicationType.value,
                };
                $productFilters.indicationFilterTypes.push(newFilter);
            }
        });
    }

    if ($type !== 'ca' && $type !== 'd' && $type !== '') {
        // eslint-disable-next-line max-len
        solrData.facet_counts.facet_pivot.ContextCategoryProperty_ss.forEach((contextCategoryProperty) => {
            const newFilter = {
                name: contextCategoryProperty.value,
                count: contextCategoryProperty.count,
                value: contextCategoryProperty.value,
            };
            $productFilters.contextCategoryFilters.push(newFilter);
        });
    }

    if ($type === 'd') {
        $mainFilters.catalogs.forEach((catalog) => {
            solrData.facet_counts.facet_pivot.main_categories_tax_ids.forEach((categoryFilter) => {
                if (String(categoryFilter.value).endsWith(catalog.identifier) && categoryFilter.value.split('#').length === 3) {
                    const tempChildFilter = {
                        name: catalog.name,
                        title: catalog.title,
                        identifier: catalog.identifier,
                        count: categoryFilter.count,
                    };
                    $productFilters.catalogFilters.push(tempChildFilter);
                }
            });
        });
    }
    // showFacets(solrData);
}

// show facets depending on search type
// function showFacets(solrData) {
//     const {
//         searchFacetData,
//         // mobileSearchFacetData,
//         filterData,
//         // mobileFilterData,
//     } = getLegacyFilterHtml(solrData);

//     jQuery('#search-results__navigation').append(searchFacetData);
//     // jQuery('#search-results-mobile__navigation').append(mobileSearchFacetData);
//     jQuery('#search-results__navigation').append(filterData);
//     // jQuery('#search-results-mobile__navigation').append(mobileFilterData);

//     initFacetEventHandlers();
// }

function initFacetEventHandlers() {
    // on mobile menu
    // eslint-disable-next-line func-names
    // jQuery('body').on('click', '.catalog-filter__button', () => {
    //     $('.catalog-filter__menu').toggleClass('mdc-menu-surface--open');
    //     $('.catalog-filter__menu').toggle();
    //     $('.search-results-mobile__navigation').toggle();
    // });

    // on division filter
    // eslint-disable-next-line func-names
    jQuery('body').on('click', '.mdc-checkbox__native-control--division', function () {
        const catalogID = jQuery(this).attr('data-id');
        let newurl = `${window.location.origin + window.location.pathname}?`;
        newurl += ($query && $query !== '') ? `q=${$query}&cat=${catalogID}` : `cat=${catalogID}`;
        window.location.href = newurl;
    });

    // on catalog filters
    // eslint-disable-next-line func-names
    jQuery('body').on('click', '.mdc-checkbox__native-control--catalog', function () {
        const categoryID = jQuery(this).attr('data-id');
        let newurl = `${window.location.origin + window.location.pathname}?`;
        newurl += ($query && $query !== '') ? `q=${$query}&cat=${categoryID}` : `cat=${categoryID}`;
        window.location.href = newurl;
    });
    // eslint-disable-next-line func-names
    jQuery('body').on('click', '.mdc-checkbox__native-control--main-procedure', function () {
        const categoryID = jQuery(this).attr('data-id');
        let newurl = `${window.location.origin + window.location.pathname}?`;
        newurl += ($query && $query !== '') ? `q=${$query}&cat=${categoryID}` : `cat=${categoryID}`;
        window.location.href = newurl;
    });

    // on indication filter
    // eslint-disable-next-line func-names
    jQuery('body').on('click', '.mdc-checkbox__native-control--procedure', function () {
        let newurl = `${window.location.origin + window.location.pathname}?`;
        const categoryID = jQuery(this).attr('data-id');
        if (jQuery(this).is(':checked')) {
            newurl += ($query && $query !== '') ? `q=${$query}&cat=${$category}&sc=${categoryID}` : `cat=${$category}&sc=${categoryID}`;
            $dataSubcategoryArray.forEach((datasp) => {
                if (datasp !== '') {
                    newurl += `,${datasp}`;
                }
            });
        } else {
            newurl += ($query && $query !== '') ? `q=${$query}&cat=${$category}&sc=` : `cat=${$category}&sc=`;
            let i = 1;
            $dataSubcategoryArray.forEach((datasp) => {
                if (datasp !== '' && datasp !== categoryID) {
                    newurl += i !== 1 ? `,${datasp}` : datasp;
                    i++;
                }
            });
        }
        $properties.forEach((property) => {
            if (property !== '') {
                newurl += `&property=${property}`;
            }
        });
        $rangeproperties.forEach((propertyID) => {
            newurl += propertyID !== '' ? `&rangeproperty=${propertyID}` : '';
        });
        $dataIndicationTypeArray.forEach((indicationType) => {
            newurl += indicationType !== '' ? `&pt=${indicationType}` : '';
        });
        window.location.href = newurl.replace(/#/g, '%23');
    });

    // on category filter
    // eslint-disable-next-line func-names
    jQuery('body').on('click', '.mdc-checkbox__native-control--category', function () {
        let newurl = `${window.location.origin + window.location.pathname}?`;
        const categoryID = jQuery(this).attr('data-id');
        if (jQuery(this).is(':checked')) {
            newurl += ($query && $query !== '') ? `q=${$query}&cat=${$category}&sp=${categoryID}` : `cat=${$category}&sp=${categoryID}`;
            $dataSubcategoryArray.forEach((datasc) => {
                if (datasc !== '') {
                    newurl += `,${datasc}`;
                }
            });
        } else {
            newurl += ($query && $query !== '') ? `q=${$query}&cat=${$category}&sp=` : `cat=${$category}&sp=`;
            let i = 1;
            $dataSubcategoryArray.forEach((datasc) => {
                if (datasc !== '' && datasc !== categoryID) {
                    newurl += i !== 1 ? `,${datasc}` : datasc;
                    i++;
                }
            });
        }
        $properties.forEach((property) => {
            if (property !== '') {
                newurl += `&property=${property}`;
            }
        });
        $rangeproperties.forEach((propertyID) => {
            newurl += propertyID !== '' ? `&rangeproperty=${propertyID}` : '';
        });
        $dataIndicationTypeArray.forEach((indicationType) => {
            newurl += indicationType !== '' ? `&pt=${indicationType}` : '';
        });
        window.location.href = newurl.replace(/#/g, '%23');
    });

    // on property filters
    // eslint-disable-next-line func-names
    jQuery('body').on('click', '.mdc-checkbox__native-control--property', function () {
        const checkBoxValue = jQuery(this).attr('data-value').replace(/%22/g, '"');
        const checkBoxName = jQuery(this).attr('data-name');
        const newEncodedValue = encodeURIComponent(checkBoxValue);
        let newurl = window.location.origin + window.location.pathname + $apiURLparam;

        $rangeproperties.forEach((propertyID) => {
            newurl += propertyID !== '' ? `&rangeproperty=${propertyID}` : '';
        });

        $dataIndicationTypeArray.forEach((indicationType) => {
            newurl += indicationType !== '' ? `&pt=${indicationType}` : '';
        });

        let newurlFilter = '&contextCategory=';
        $contextCategoryArray.forEach((contextCategoryFilter) => {
            newurlFilter += `${contextCategoryFilter},`;
        });

        if (newurlFilter !== '&contextCategory=') {
            newurl += newurlFilter.slice(0, -1);
        }

        if ($properties.length) {
            let exist = false;
            $properties.forEach((propertyID) => {
                let tempProperty = propertyID;
                const tempPropertyName = propertyID.split(':');
                if (decodeURIComponent(tempPropertyName[0]) === checkBoxName.replace(/%23/g, '#')) {
                    exist = true;
                    if (jQuery(this).is(':checked')) {
                        // eslint-disable-next-line no-param-reassign
                        tempProperty += `-OR-${newEncodedValue}`;
                    } else {
                        const propertyIDvalue = tempProperty.replace(`${tempProperty.split(':')[0]}:`, '');
                        const singlePopertyIDValues = propertyIDvalue.split('-OR-');
                        let tempPropertyValue = `${checkBoxName}:`;
                        if (singlePopertyIDValues.length > 1) {
                            let i = 0;
                            singlePopertyIDValues.forEach((singlePopertyIDValue) => {
                                if (singlePopertyIDValue !== checkBoxValue) {
                                    tempPropertyValue += i !== 0 ? `-OR-${singlePopertyIDValue}` : singlePopertyIDValue;
                                    i++;
                                }
                            });
                            // eslint-disable-next-line no-param-reassign
                            tempProperty = tempPropertyValue;
                        } else {
                            // eslint-disable-next-line no-param-reassign
                            tempProperty = '';
                        }
                    }
                }
                newurl += tempProperty !== '' ? `&property=${tempProperty}` : '';
            });
            if (!exist) {
                newurl += `&property=${checkBoxName}:${newEncodedValue}`;
            }
        } else {
            newurl += `&property=${checkBoxName}:${newEncodedValue}`;
        }
        window.location.href = newurl.replace(/#/g, '%23');
    });

    // on indication type filters
    // eslint-disable-next-line func-names
    jQuery('body').on('click', '.mdc-checkbox__native-control--indication-type', function () {
        const checkBoxValue = jQuery(this).attr('data-value');
        let newurl = window.location.origin + window.location.pathname + $apiURLparam;
        $rangeproperties.forEach((propertyID) => {
            newurl += propertyID !== '' ? `&rangeproperty=${propertyID}` : '';
        });
        $properties.forEach((property) => {
            if (property !== '') {
                newurl += `&property=${property}`;
            }
        });

        let newurlFilter = '&contextCategory=';
        $contextCategoryArray.forEach((contextCategoryFilter) => {
            newurlFilter += `${contextCategoryFilter},`;
        });

        if (newurlFilter !== '&contextCategory=') {
            newurl += newurlFilter.slice(0, -1);
        }

        if (jQuery(this).is(':checked')) {
            newurl += `&pt=${checkBoxValue}`;
        } else {
            $dataIndicationTypeArray.forEach((indicationType) => {
                if (checkBoxValue !== indicationType) {
                    newurl += `&pt=${checkBoxValue}`;
                }
            });
        }
        window.location.href = newurl.replace(/#/g, '%23');
    });

    // on context category filters
    // eslint-disable-next-line func-names
    jQuery('body').on('click', '.mdc-checkbox__native-control--contextcategory', function () {
        const checkBoxValue = jQuery(this).attr('data-value');
        let newurl = window.location.origin + window.location.pathname + $apiURLparam;
        $rangeproperties.forEach((propertyID) => {
            newurl += propertyID !== '' ? `&rangeproperty=${propertyID}` : '';
        });
        $properties.forEach((property) => {
            if (property !== '') {
                newurl += `&property=${property}`;
            }
        });

        $dataIndicationTypeArray.forEach((indicationType) => {
            newurl += `&pt=${indicationType}`;
        });

        if (jQuery(this).is(':checked')) {
            newurl += `&contextCategory=${checkBoxValue}`;
            $contextCategoryArray.forEach((contextCategoryFilter) => {
                if (contextCategoryFilter !== '') {
                    newurl += `,${contextCategoryFilter}`;
                }
            });
        } else {
            let newurlFilter = '&contextCategory=';
            $contextCategoryArray.forEach((contextCategoryFilter) => {
                if (checkBoxValue !== contextCategoryFilter) {
                    newurlFilter += `${contextCategoryFilter},`;
                }
            });

            if (newurlFilter !== '&contextCategory=') {
                newurl += newurlFilter.slice(0, -1);
            }
        }

        window.location.href = newurl.replace(/#/g, '%23');
    });

    initFilterSliders();
}

function getLegacyFilterHtml(solrData) {
    let searchFacetData = '';
    let isOnlyFacet = true;

    // present indication filters if category or catalog search
    if ($type === 'c' || $type === 'ca') {
        if ($productFilters.indicationFilters.length > 0) {
            isOnlyFacet = false;
            $productFilters.indicationFilters.forEach((mainIndicationFilter, index) => {
                searchFacetData += `<a data-bs-toggle="collapse" href="#procedure${index}" role="button" aria-expanded="true" aria-controls="procedure${index}">
                    <span style="display:block" class="mdc-list-group__subheader search-results__navigation-header">
                        ${mainIndicationFilter.name}
                        <span class="rfct-filter__open-icon rfct-button__icon-svg">
                            <svg><use xlink:href="/static_2x/static/svg/spritemap.svg#add"></use></svg>
                        </span>
                        <span class="rfct-filter__close-icon rfct-button__icon-svg">
                            <svg><use xlink:href="/static_2x/static/svg/spritemap.svg#remove"></use></svg>
                        </span>
                    </span>
                </a><ul class="search-results__navigation-content mdc-list collapse show" id="procedure${index}">`;
                const checkboxClass = $type === 'ca' ? 'mdc-checkbox__native-control--main-procedure' : 'mdc-checkbox__native-control--procedure';
                mainIndicationFilter.children.forEach((indicationFilter) => {
                    if (indicationFilter.selected) {
                        searchFacetData += `<li class="mdc-list-item">
                            <span class="mdc-list-item__graphic mdc-form-field">
                                <div class="mdc-checkbox">
                                    <input type="checkbox" class="mdc-checkbox__native-control ${checkboxClass}" id="check_${indicationFilter.identifier}" data-id="${indicationFilter.identifier}" name="${indicationFilter.name}" checked />
                                    <div class="mdc-checkbox__background">
                                        <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24" >
                                            <path class="mdc-checkbox__checkmark-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
                                        </svg>
                                        <div class="mdc-checkbox__mixedmark"></div>
                                    </div>
                                </div>
                            </span>
                            <label class="mdc-list-item__text" for="check_${indicationFilter.identifier}">${indicationFilter.name} (${indicationFilter.count})</label>
                        </li>`;
                    } else {
                        searchFacetData += `<li class="mdc-list-item">
                            <span class="mdc-list-item__graphic mdc-form-field">
                                <div class="mdc-checkbox">
                                    <input type="checkbox" class="mdc-checkbox__native-control ${checkboxClass}" id="check_${indicationFilter.identifier}" data-id="${indicationFilter.identifier}" name="${indicationFilter.name}" />
                                    <div class="mdc-checkbox__background">
                                        <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24" >
                                            <path class="mdc-checkbox__checkmark-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
                                        </svg>
                                        <div class="mdc-checkbox__mixedmark"></div>
                                    </div>
                                </div>
                            </span>
                            <label class="mdc-list-item__text" for="check_${indicationFilter.identifier}">${indicationFilter.name} (${indicationFilter.count})</label>
                        </li>`;
                    }
                });
                searchFacetData += '</ul>';
            });
        }
    }

    // present indication type filters if indication search
    if ($type === 'p') {
        if ($productFilters.indicationFilterTypes.length > 0) {
            isOnlyFacet = false;
            searchFacetData += `<a data-bs-toggle="collapse" href="#indicationtype" role="button" aria-expanded="true" aria-controls="indicationtype">
                <span style="display:block" class="mdc-list-group__subheader search-results__navigation-header">
                    ${$globalConfig.textResources.productCatalogConnectorConfig.labelIndicationFilterType}
                    <span class="rfct-filter__open-icon rfct-button__icon-svg">
                        <svg><use xlink:href="/static_2x/static/svg/spritemap.svg#add"></use></svg>
                    </span>
                    <span class="rfct-filter__close-icon rfct-button__icon-svg">
                        <svg><use xlink:href="/static_2x/static/svg/spritemap.svg#remove"></use></svg>
                    </span>
                </span>
            </a><ul class="search-results__navigation-content mdc-list collapse show" id="indicationtype">`;

            $productFilters.indicationFilterTypes.forEach((indicationFilterType) => {
                let checked = false;

                const indicationTypeFilterName = `indicationTypes.${indicationFilterType.name}`;
                $dataIndicationTypeArray.forEach((selectedIndicationFilterType) => {
                    if (selectedIndicationFilterType.replace(/%23/g, '#') === indicationFilterType.value) {
                        checked = true;
                    }
                });
                if (checked) {
                    searchFacetData += `<li class="mdc-list-item">
                        <span class="mdc-list-item__graphic mdc-form-field">
                            <div class="mdc-checkbox">
                                <input type="checkbox" class="mdc-checkbox__native-control mdc-checkbox__native-control--indication-type" id="check_${indicationFilterType.name}" data-id="${indicationFilterType.name}" data-value="${indicationFilterType.value}" name="${indicationFilterType.name}" checked />
                                <div class="mdc-checkbox__background">
                                    <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24" >
                                        <path class="mdc-checkbox__checkmark-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
                                    </svg>
                                    <div class="mdc-checkbox__mixedmark"></div>
                                </div>
                            </div>
                        </span>
                        <label class="mdc-list-item__text" for="check_${indicationFilterType.name}">
                            ${$globalConfig.textResources.productCatalogConnectorConfig[indicationTypeFilterName]} (${indicationFilterType.count})
                        </label>
                    </li>`;
                } else {
                    searchFacetData += `<li class="mdc-list-item">
                        <span class="mdc-list-item__graphic mdc-form-field">
                            <div class="mdc-checkbox">
                                <input type="checkbox" class="mdc-checkbox__native-control mdc-checkbox__native-control--indication-type" id="check_${indicationFilterType.name}" data-id="${indicationFilterType.name}" data-value="${indicationFilterType.value}" name="${indicationFilterType.name}" />
                                <div class="mdc-checkbox__background">
                                    <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24" >
                                        <path class="mdc-checkbox__checkmark-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
                                    </svg>
                                    <div class="mdc-checkbox__mixedmark"></div>
                                </div>
                            </div>
                        </span>
                        <label class="mdc-list-item__text" for="check_${indicationFilterType.name}">
                            ${$globalConfig.textResources.productCatalogConnectorConfig[indicationTypeFilterName]} (${indicationFilterType.count})
                        </label>
                    </li>`;
                }
            });

            searchFacetData += '</ul>';
        }
    }

    // present category filters if indication or catalog search
    if ($type === 'p' || $type === 'ca') {
        // Present category filters

        if ($productFilters.categoryFilters.length > 0) {
            isOnlyFacet = false;

            $productFilters.categoryFilters.forEach((mainCategoryFilter, index) => {
                searchFacetData += `<a data-bs-toggle="collapse" href="#category${index}" role="button" aria-expanded="true" aria-controls="category${index}">
                    <span style="display:block" class="mdc-list-group__subheader search-results__navigation-header">
                        ${mainCategoryFilter.name}
                        <span class="rfct-filter__open-icon rfct-button__icon-svg">
                            <svg><use xlink:href="/static_2x/static/svg/spritemap.svg#add"></use></svg>
                        </span>
                        <span class="rfct-filter__close-icon rfct-button__icon-svg">
                            <svg><use xlink:href="/static_2x/static/svg/spritemap.svg#remove"></use></svg>
                        </span>
                    </span>
                </a><ul class="search-results__navigation-content mdc-list collapse show" id="category${index}">`;

                let checkboxClass = '';
                if ($type === 'ca') {
                    checkboxClass = 'mdc-checkbox__native-control--catalog';
                } else {
                    checkboxClass = 'mdc-checkbox__native-control--category';
                }
                mainCategoryFilter.children.forEach((categoryFilter) => {
                    if (categoryFilter.selected) {
                        searchFacetData += `<li class="mdc-list-item">
                            <span class="mdc-list-item__graphic mdc-form-field">
                                <div class="mdc-checkbox">
                                    <input type="checkbox" class="mdc-checkbox__native-control ${checkboxClass}" id="check_${categoryFilter.identifier}" data-id="${categoryFilter.identifier}" name="${categoryFilter.name}" checked />
                                    <div class="mdc-checkbox__background">
                                        <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24" >
                                            <path class="mdc-checkbox__checkmark-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
                                        </svg>
                                        <div class="mdc-checkbox__mixedmark"></div>
                                    </div>
                                </div>
                            </span>
                            <label class="mdc-list-item__text" for="check_${categoryFilter.identifier}">
                                ${categoryFilter.name} (${categoryFilter.count})
                            </label>
                        </li>`;
                    } else {
                        searchFacetData += `<li class="mdc-list-item">
                            <span class="mdc-list-item__graphic mdc-form-field">
                                <div class="mdc-checkbox">
                                    <input type="checkbox" class="mdc-checkbox__native-control ${checkboxClass}" id="check_${categoryFilter.identifier}" data-id="${categoryFilter.identifier}" name="${categoryFilter.name}" />
                                    <div class="mdc-checkbox__background">
                                        <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24" >
                                            <path class="mdc-checkbox__checkmark-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
                                        </svg>
                                        <div class="mdc-checkbox__mixedmark"></div>
                                    </div>
                                </div>
                            </span>
                            <label class="mdc-list-item__text" for="check_${categoryFilter.identifier}">
                                ${categoryFilter.name} (${categoryFilter.count})
                            </label>
                        </li>`;
                    }
                });
                searchFacetData += '</ul>';
            });
        }
    }

    // present context category filters if indication search
    if ($type === 'p') {
        if ($productFilters.contextCategoryFilters.length > 0) {
            isOnlyFacet = false;
            searchFacetData += `<a data-bs-toggle="collapse" href="#contextcategory" role="button" aria-expanded="true" aria-controls="contextcategory">
                <span style="display:block" class="mdc-list-group__subheader search-results__navigation-header">
                    ${$globalConfig.textResources.productCatalogConnectorConfig.labelForContextCategoryAttributeFilter}
                    <span class="rfct-filter__open-icon rfct-button__icon-svg">
                        <svg><use xlink:href="/static_2x/static/svg/spritemap.svg#add"></use></svg>
                    </span>
                    <span class="rfct-filter__close-icon rfct-button__icon-svg">
                        <svg><use xlink:href="/static_2x/static/svg/spritemap.svg#remove"></use></svg>
                    </span>
                </span>
            </a><ul class="search-results__navigation-content mdc-list collapse show" id="contextcategory">`;

            $productFilters.contextCategoryFilters.forEach((contextCategoryFilter) => {
                let checked = false;

                $contextCategoryArray.forEach((selectedContextCategory) => {
                    if (selectedContextCategory === contextCategoryFilter.value) {
                        checked = true;
                    }
                });
                if (checked) {
                    searchFacetData += `<li class="mdc-list-item">
                        <span class="mdc-list-item__graphic mdc-form-field">
                            <div class="mdc-checkbox">
                                <input type="checkbox" class="mdc-checkbox__native-control mdc-checkbox__native-control--contextcategory" id="check_${contextCategoryFilter.name}" data-id="${contextCategoryFilter.name}" data-value="${contextCategoryFilter.value}" name="${contextCategoryFilter.name}" checked />
                                <div class="mdc-checkbox__background">
                                    <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24" >
                                        <path class="mdc-checkbox__checkmark-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
                                    </svg>
                                    <div class="mdc-checkbox__mixedmark"></div>
                                </div>
                            </div>
                        </span>
                        <label class="mdc-list-item__text" for="check_${contextCategoryFilter.name}">
                        ${contextCategoryFilter.name} (${contextCategoryFilter.count})
                        </label>
                    </li>`;
                } else {
                    searchFacetData += `<li class="mdc-list-item">
                        <span class="mdc-list-item__graphic mdc-form-field">
                            <div class="mdc-checkbox">
                                <input type="checkbox" class="mdc-checkbox__native-control mdc-checkbox__native-control--contextcategory" id="check_${contextCategoryFilter.name}" data-id="${contextCategoryFilter.name}" data-value="${contextCategoryFilter.value}" name="${contextCategoryFilter.name}" />
                                <div class="mdc-checkbox__background">
                                    <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24" >
                                        <path class="mdc-checkbox__checkmark-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
                                    </svg>
                                    <div class="mdc-checkbox__mixedmark"></div>
                                </div>
                            </div>
                        </span>
                        <label class="mdc-list-item__text" for="check_${contextCategoryFilter.name}">
                            ${contextCategoryFilter.name} (${contextCategoryFilter.count})
                        </label>
                    </li>`;
                }
            });

            searchFacetData += '</ul>';
        }
    }

    // present catalog filters division search
    if ($type === 'd') {
        if ($productFilters.catalogFilters.length > 0) {
            isOnlyFacet = false;
            searchFacetData += `<a data-bs-toggle="collapse" href="#division" role="button" aria-expanded="true" aria-controls="division">
                    <span style="display:block" class="mdc-list-group__subheader search-results__navigation-header">
                        ${$globalConfig.textResources.productCatalogConnectorConfig.labelMainCategoryFilter}
                        <span class="rfct-filter__open-icon rfct-button__icon-svg">
                            <svg><use xlink:href="/static_2x/static/svg/spritemap.svg#add"></use></svg>
                        </span>
                        <span class="rfct-filter__close-icon rfct-button__icon-svg">
                            <svg><use xlink:href="/static_2x/static/svg/spritemap.svg#remove"></use></svg>
                        </span>
                    </span>
                </a><ul class="search-results__navigation-content mdc-list collapse show" id="division">`;
            $productFilters.catalogFilters.forEach((catalogFilter) => {
                if (catalogFilter.selected) {
                    searchFacetData += `<li class="mdc-list-item">
                        <span class="mdc-list-item__graphic mdc-form-field">
                            <div class="mdc-checkbox">
                                <input type="checkbox" class="mdc-checkbox__native-control mdc-checkbox__native-control--division" id="check_${catalogFilter.identifier}" data-id="${catalogFilter.identifier}" name="${catalogFilter.name}" checked />
                                <div class="mdc-checkbox__background">
                                    <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24" >
                                        <path class="mdc-checkbox__checkmark-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
                                    </svg>
                                    <div class="mdc-checkbox__mixedmark"></div>
                                </div>
                            </div>
                        </span>
                        <label class="mdc-list-item__text" for="check_${catalogFilter.identifier}">
                            ${catalogFilter.name} (${catalogFilter.count})
                        </label>
                    </li>`;
                } else {
                    searchFacetData += `<li class="mdc-list-item">
                        <span class="mdc-list-item__graphic mdc-form-field">
                            <div class="mdc-checkbox">
                                <input type="checkbox" class="mdc-checkbox__native-control mdc-checkbox__native-control--division" id="check_${catalogFilter.identifier}" data-id="${catalogFilter.identifier}" name="${catalogFilter.name}" />
                                <div class="mdc-checkbox__background">
                                    <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24" >
                                        <path class="mdc-checkbox__checkmark-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
                                    </svg>
                                    <div class="mdc-checkbox__mixedmark"></div>
                                </div>
                            </div>
                        </span>
                        <label class="mdc-list-item__text" for="check_${catalogFilter.identifier}">
                            ${catalogFilter.name} (${catalogFilter.count})
                        </label>
                    </li>`;
                }
            });
            searchFacetData += '</ul>';
        }
    }

    // present property filters
    let filterData = '';
    if ($type === 'c' || $type === 'p') {
        let areaExpanded = 'false';
        let areaExpandedChild = 'collapse';
        let collapsed = 'collapsed';
        if (($properties && $properties.length) || ($rangeproperties && $rangeproperties.length)) {
            areaExpanded = 'true';
            areaExpandedChild = 'collapse in show';
            collapsed = '';
        }

        // correction if this is the first filter
        if (isOnlyFacet) {
            areaExpanded = 'true';
            areaExpandedChild = 'collapse in show';
            collapsed = '';
        }
        filterData += `<a data-bs-toggle="collapse" href="#moreFilters" role="button" aria-expanded="${areaExpanded}" aria-controls="moreFilters" class="${collapsed}">
            <span style="display:block" class="mdc-list-group__subheader search-results__navigation-header search-results__navigation-header--main">
                ${$globalConfig.textResources.productCatalogConnectorConfig.labelMoreFilter}
                <span class="rfct-filter__open-icon rfct-button__icon-svg">
                    <svg><use xlink:href="/static_2x/static/svg/spritemap.svg#add"></use></svg>
                </span>
                <span class="rfct-filter__close-icon rfct-button__icon-svg">
                    <svg><use xlink:href="/static_2x/static/svg/spritemap.svg#remove"></use></svg>
                </span>
            </span>
        </a>
        <div class="${areaExpandedChild}" id="moreFilters">`;
        $productFilters.propertyFilters.forEach((filterPropertyFacet, index) => {
            if (solrData.facet_counts.facet_fields[filterPropertyFacet.id] && filterPropertyFacet.id.includes('_ss') && solrData.facet_counts.facet_fields[filterPropertyFacet.id].length > 0) {
                let showFilter = false;
                // eslint-disable-next-line max-len
                solrData.facet_counts.facet_fields[filterPropertyFacet.id].forEach((filterRawValue, filterValueIndex) => {
                    if (filterValueIndex % 2 !== 0 && filterRawValue > 0) {
                        showFilter = true;
                    }
                    if (filterValueIndex % 2 === 0) {
                        $properties.forEach((propertyFilter) => {
                            if (propertyFilter !== '') {
                                const propertyID = propertyFilter.split(':')[0];
                                const propertyValues = propertyFilter.replace(`${propertyFilter.split(':')[0]}:`, '').split('-OR-');
                                propertyValues.forEach((propertyValue) => {
                                    if (propertyID === filterPropertyFacet.id && propertyValue !== '' && propertyValue === filterRawValue) {
                                        showFilter = true;
                                    }
                                });
                            }
                        });
                    }
                });
                if (showFilter) {
                    filterData += `<strong class="mdc-list-group__subheader mdc-list-group__subheader-property ">
                        ${decodeURIComponent(filterPropertyFacet.name)}
                        <i class="fas fa-caret-down search-results__navigation-icon" style="margin-right: 10px; display: none;"></i>
                    </strong>
                    <ul class="search-results__navigation-content mdc-list collapse show" id="property${index}">`;

                    // checkboxes
                    // eslint-disable-next-line max-len
                    solrData.facet_counts.facet_fields[filterPropertyFacet.id].forEach((filterRawValue, filterValueIndex) => {
                        const filterValue = {};
                        if (filterValueIndex % 2 === 0) {
                            let checked = false;
                            filterValue.name = filterRawValue;
                            // eslint-disable-next-line max-len
                            filterValue.count = solrData.facet_counts.facet_fields[filterPropertyFacet.id][filterValueIndex + 1];
                            $properties.forEach((propertyFilter) => {
                                if (propertyFilter !== '') {
                                    const propertyID = propertyFilter.split(':')[0];
                                    const propertyValues = propertyFilter.replace(`${propertyFilter.split(':')[0]}:`, '').split('-OR-');
                                    propertyValues.forEach((propertyValue) => {
                                        if (propertyID === filterPropertyFacet.id && propertyValue !== '' && propertyValue === filterRawValue) {
                                            checked = true;
                                        }
                                    });
                                }
                            });
                            filterPropertyFacet.unit = (filterPropertyFacet.unit === '°' || filterPropertyFacet.unit === '"') ? filterPropertyFacet.unit : ` ${filterPropertyFacet.unit}`;
                            if (checked) {
                                filterData += `<li class="mdc-list-item">
                                    <span class="mdc-list-item__graphic mdc-form-field">
                                        <div class="mdc-checkbox">
                                            <input type="checkbox" class="mdc-checkbox__native-control mdc-checkbox__native-control--property" id="property_${filterPropertyFacet.id}:${filterValue.name.replace(/"/g, '%22')}" data-id="${filterPropertyFacet.id}:${filterValue.name.replace(/"/g, '%22')}" data-name="${filterPropertyFacet.id}" data-value="${filterValue.name.replace(/"/g, '%22')}" name="${filterPropertyFacet.id}:${filterValue.name.replace(/"/g, '%22')}" checked />
                                            <div class="mdc-checkbox__background">
                                                <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24" >
                                                    <path class="mdc-checkbox__checkmark-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
                                                </svg>
                                                <div class="mdc-checkbox__mixedmark"></div>
                                            </div>
                                        </div>
                                    </span>
                                    <label class="mdc-list-item__text" for="property_${filterPropertyFacet.id}:${filterValue.name.replace(/"/g, '%22')}">
                                        ${filterValue.name}${filterPropertyFacet.unit} (${filterValue.count})
                                    </label>
                                </li>`;
                            } else if (filterValue.count > 0) {
                                filterData += `<li class="mdc-list-item">
                                    <span class="mdc-list-item__graphic mdc-form-field">
                                        <div class="mdc-checkbox">
                                            <input type="checkbox" class="mdc-checkbox__native-control mdc-checkbox__native-control--property" id="property_${filterPropertyFacet.id}:${filterValue.name.replace(/"/g, '%22')}" data-id="${filterPropertyFacet.id}:${filterValue.name.replace(/"/g, '%22')}" data-name="${filterPropertyFacet.id}" data-value="${filterValue.name.replace(/"/g, '%22')}" name="${filterPropertyFacet.id}:${filterValue.name.replace(/"/g, '%22')}"/>
                                            <div class="mdc-checkbox__background">
                                                <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24" >
                                                    <path class="mdc-checkbox__checkmark-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
                                                </svg>
                                                <div class="mdc-checkbox__mixedmark"></div>
                                            </div>
                                        </div>
                                    </span>
                                    <label class="mdc-list-item__text" for="property_${filterPropertyFacet.id}:${filterValue.name.replace(/"/g, '%22')}">
                                        ${filterValue.name}${filterPropertyFacet.unit} (${filterValue.count})
                                    </label>
                                </li>`;
                            }
                        }
                    });
                    filterData += '</ul>';
                }
            } else if (solrData.facet_counts.facet_fields[filterPropertyFacet.id] && filterPropertyFacet.id.includes('_fs') && solrData.facet_counts.facet_fields[filterPropertyFacet.id].length > 0) {
                let filterCount = 0;
                const values = [];
                // eslint-disable-next-line max-len
                solrData.facet_counts.facet_fields[filterPropertyFacet.id].forEach((filterRawValue, filterValueIndex) => {
                    if (filterValueIndex % 2 === 0) {
                        values.push(parseFloat(filterRawValue));
                    } else {
                        // eslint-disable-next-line max-len
                        filterCount += solrData.facet_counts.facet_fields[filterPropertyFacet.id][filterValueIndex];
                    }
                });

                if (filterCount > 1 && values.length > 1) {
                    filterData += `<strong class="mdc-list-group__subheader mdc-list-group__subheader-property ">
                        ${filterPropertyFacet.name}
                        <i class="fas fa-caret-down search-results__navigation-icon" style="margin-right: 10px; display: none;"></i>
                    </strong>`;
                    // sliders
                    // eslint-disable-next-line prefer-spread
                    const minValue = Math.min.apply(Math, values);
                    // eslint-disable-next-line prefer-spread
                    const maxValue = Math.max.apply(Math, values);
                    let intMinValue = Math.floor(minValue);
                    let intMaxValue = Math.ceil(maxValue);
                    let initSliderValues = '';
                    $rangeproperties.forEach((propertyIDs) => {
                        const propertyIDSsList = propertyIDs.split(',');
                        propertyIDSsList.forEach((propertyID) => {
                            if (propertyID.includes(filterPropertyFacet.id)) {
                                initSliderValues = propertyID.replace(`${propertyID.split(':')[0]}:`, '');
                                // eslint-disable-next-line prefer-destructuring
                                intMinValue = initSliderValues.split('-TO-')[0];
                                // eslint-disable-next-line prefer-destructuring
                                intMaxValue = initSliderValues.split('-TO-')[1];
                            }
                        });
                    });
                    const defaultMinValue = Math.floor(minValue);
                    const defaultMaxValue = Math.ceil(maxValue);
                    const filterUnit = filterPropertyFacet.unit && filterPropertyFacet.unit !== '' ? ` (${filterPropertyFacet.unit})` : '';

                    // adding label for multirange slider
                    filterData += '<div class="multi-range-slider m-3">';
                    // eslint-disable-next-line max-len
                    if ($globalConfig.textResources.productCatalogConnectorConfig.labelMinSuffix && $globalConfig.textResources.productCatalogConnectorConfig.labelMinSuffix) {
                        filterData += `<input aria-label="${$globalConfig.textResources.productCatalogConnectorConfig.labelMinSuffix} ${filterPropertyFacet.name}" type="range" id="input-left" data-id="${filterPropertyFacet.id}" class="multi-range-slider__input multi-range-slider__input--left" min="${defaultMinValue}" max="${defaultMaxValue}" value="${intMinValue}">
                        <input aria-label="${$globalConfig.textResources.productCatalogConnectorConfig.labelMaxSuffix} ${filterPropertyFacet.name}" type="range" id="input-right" data-id="${filterPropertyFacet.id}" class="multi-range-slider__input multi-range-slider__input--right" min="${defaultMinValue}" max="${defaultMaxValue}" value="${intMaxValue}">`;
                    } else {
                        filterData += `<input aria-label="${filterPropertyFacet.name}" type="range" id="input-left" data-id="${filterPropertyFacet.id}" class="multi-range-slider__input multi-range-slider__input--left" min="${defaultMinValue}" max="${defaultMaxValue}" value="${intMinValue}">
                        <input aria-label="${filterPropertyFacet.name}" type="range" id="input-right" data-id="${filterPropertyFacet.id}" class="multi-range-slider__input multi-range-slider__input--right" min="${defaultMinValue}" max="${defaultMaxValue}" value="${intMaxValue}">`;
                    }
                    filterData += `
                        <div class="multi-range-slider__content">
                            <div class="multi-range-slider__track"></div>
                            <div class="multi-range-slider__range"></div>
                            <div class="multi-range-slider__thumb multi-range-slider__thumb--left"></div>
                            <div class="multi-range-slider__thumb multi-range-slider__thumb--right"></div>
                        </div>
                        <div class="mt-3 text-center">
                            <span class="left-value"></span> - <span class="right-value"></span>${filterUnit}
                        </div>
                    </div>`;
                }
            }
        });
        filterData += '</div>';
    }

    return {
        searchFacetData,
        filterData,
    };
}

// slider filters init change
function initFilterSliders() {
    const sliders = document.querySelectorAll('.multi-range-slider');

    // eslint-disable-next-line camelcase
    function is_touch_device() {
        try { document.createEvent('TouchEvent'); return true; } catch (e) { return false; }
    }

    sliders.forEach((multiRangeSlider) => {
        const isMobile = is_touch_device();

        if (isMobile) {
            multiRangeSlider.classList.add('multi-range-slider--mobile');
        }

        const inputLeft = multiRangeSlider.querySelector('.multi-range-slider__input--left');
        const inputRight = multiRangeSlider.querySelector('.multi-range-slider__input--right');
        const thumbLeft = multiRangeSlider.querySelector('.multi-range-slider__content > .multi-range-slider__thumb--left');
        const thumbRight = multiRangeSlider.querySelector('.multi-range-slider__content > .multi-range-slider__thumb--right');
        const range = multiRangeSlider.querySelector('.multi-range-slider__content > .multi-range-slider__range');

        // eslint-disable-next-line func-names
        multiRangeSlider.addEventListener('mouseover', function (event) {
            const relX = event.pageX - $(this).offset().left;
            const leftPosition = $(thumbLeft).position();
            const rightPosition = $(thumbRight).position();
            // eslint-disable-next-line max-len
            const leftValue = parseFloat(relX) > parseFloat(leftPosition.left) ? parseFloat(relX) - parseFloat(leftPosition.left) : parseFloat(leftPosition.left) - parseFloat(relX);
            // eslint-disable-next-line max-len
            const rightValue = parseFloat(relX) > parseFloat(rightPosition.left) ? parseFloat(relX) - parseFloat(rightPosition.left) : parseFloat(rightPosition.left) - parseFloat(relX);
            if (rightValue > leftValue) {
                inputRight.classList.remove('multi-range-slider__input--active');
                inputLeft.classList.add('multi-range-slider__input--active');
            } else {
                inputLeft.classList.remove('multi-range-slider__input--active');
                inputRight.classList.add('multi-range-slider__input--active');
            }
        });

        multiRangeSlider.addEventListener('touchend', updateURL);

        const leftmin = parseInt(inputLeft.min);
        const leftmax = parseInt(inputLeft.max);
        inputLeft.value = Math.min(parseInt(inputLeft.value), parseInt(inputRight.value) - 1);
        const leftpercent = ((inputLeft.value - leftmin) / (leftmax - leftmin)) * 100;
        thumbLeft.style.left = `${leftpercent}%`;
        range.style.left = `${leftpercent}%`;
        multiRangeSlider.querySelector('.left-value').textContent = inputLeft.value;

        inputLeft.addEventListener('input', setLeftValue);
        inputLeft.addEventListener('mouseover', () => {
            thumbLeft.classList.add('multi-range-slider__thumb--hover');
        });
        inputLeft.addEventListener('mouseout', () => {
            thumbLeft.classList.remove('multi-range-slider__thumb--hover');
        });
        inputLeft.addEventListener('mousedown', () => {
            thumbLeft.classList.add('multi-range-slider__thumb--active');
        });
        // on left slider change
        inputLeft.addEventListener('mouseup', () => {
            thumbLeft.classList.remove('multi-range-slider__thumb--active');
            let newurl = window.location.origin + window.location.pathname + $apiURLparam;
            newurl += ((inputLeft.value !== leftmin) || (inputRight.value !== leftmax)) ? `&rangeproperty=${inputLeft.getAttribute('data-id')}:${parseFloat(inputLeft.value)}-TO-${parseFloat(inputRight.value)}` : '';
            let dataPropertyValue = `${inputLeft.getAttribute('data-id')}:${parseFloat(inputLeft.value)}-TO-${parseFloat(inputRight.value)}`;

            $properties.forEach((propertyID) => {
                newurl += propertyID !== '' ? `&property=${propertyID}` : '';
            });
            $rangeproperties.forEach((rangepropertyID) => {
                if (!decodeURIComponent(rangepropertyID).includes(decodeURIComponent(inputLeft.getAttribute('data-id'))) && rangepropertyID !== '') {
                    dataPropertyValue += `;${rangepropertyID}`;
                    newurl += `&rangeproperty=${rangepropertyID}`;
                }
            });

            $dataIndicationTypeArray.forEach((indicationType) => {
                newurl += indicationType !== '' ? `&pt=${indicationType}` : '';
            });
            jQuery('#search-results__products').attr('data-rangeproperty', dataPropertyValue);
            window.location.href = newurl.replace(/#/g, '%23');
        });

        const rightmin = parseInt(inputRight.min);
        const rightmax = parseInt(inputRight.max);
        inputRight.value = Math.max(parseInt(inputRight.value), parseInt(inputLeft.value) + 1);
        const rightpercent = ((inputRight.value - rightmin) / (rightmax - rightmin)) * 100;
        thumbRight.style.right = `${100 - rightpercent}%`;
        range.style.right = `${100 - rightpercent}%`;
        multiRangeSlider.querySelector('.right-value').textContent = inputRight.value;

        inputRight.addEventListener('input', setRightValue);
        inputRight.addEventListener('mouseover', () => {
            thumbRight.classList.add('multi-range-slider__thumb--hover');
        });
        inputRight.addEventListener('mouseout', () => {
            thumbRight.classList.remove('multi-range-slider__thumb--hover');
        });
        inputRight.addEventListener('mousedown', () => {
            thumbRight.classList.add('multi-range-slider__thumb--active');
        });

        // on right slider change
        inputRight.addEventListener('mouseup', () => {
            thumbRight.classList.remove('multi-range-slider__thumb--active');
            let newurl = window.location.origin + window.location.pathname + $apiURLparam;
            newurl += ((inputLeft.value !== rightmin) || (inputRight.value !== rightmax)) ? `&rangeproperty=${inputLeft.getAttribute('data-id')}:${parseFloat(inputLeft.value)}-TO-${parseFloat(inputRight.value)}` : '';
            let dataPropertyValue = `${inputRight.getAttribute('data-id')}:${parseFloat(inputLeft.value)}-TO-${parseFloat(inputRight.value)}`;
            let propertyDataList = '';
            let rangepropertyDataList = '';

            const selectedProperties = window.location.search.substring(1);

            if (selectedProperties && selectedProperties !== '') {
                const selectedPropertiesList = selectedProperties.split('&');
                selectedPropertiesList.forEach((selectedPropertiesValue) => {
                    if (selectedPropertiesValue.split('=')[0] === 'property' && selectedPropertiesValue.split('=')[1] !== '') {
                        propertyDataList += `${decodeURIComponent(selectedPropertiesValue.split('=')[1])};`;
                    }
                    if (selectedPropertiesValue.split('=')[0] === 'rangeproperty' && selectedPropertiesValue.split('=')[1] !== '') {
                        rangepropertyDataList += `${decodeURIComponent(selectedPropertiesValue.split('=')[1])};`;
                    }
                });
            }

            const propertyDataArray = propertyDataList.split(';');
            const rangepropertyDataArray = rangepropertyDataList.split(';');
            const indicationTypes = jQuery('#search-results__products').attr('data-indication-types') ? jQuery('#search-results__products').attr('data-indication-types').split(';') : [];

            propertyDataArray.forEach((propertyID) => {
                newurl += propertyID !== '' ? `&property=${propertyID}` : '';
            });
            rangepropertyDataArray.forEach((rangepropertyID) => {
                if (!decodeURIComponent(rangepropertyID).includes(decodeURIComponent(inputRight.getAttribute('data-id'))) && rangepropertyID !== '') {
                    dataPropertyValue += `;${rangepropertyID}`;
                    newurl += `&rangeproperty=${rangepropertyID}`;
                }
            });

            indicationTypes.forEach((indicationType) => {
                newurl += indicationType !== '' ? `&propertyType=${indicationType}` : '';
            });

            jQuery('#search-results__products').attr('data-rangeproperty', dataPropertyValue);
            window.location.href = newurl.replace(/#/g, '%23');
        });
    });

    function updateURL() {
        const multiRangeSlider = this.closest('.multi-range-slider');

        const inputLeft = multiRangeSlider.querySelector('.multi-range-slider__input--left');
        const inputRight = multiRangeSlider.querySelector('.multi-range-slider__input--right');

        const leftmin = parseInt(inputLeft.min);
        const leftmax = parseInt(inputLeft.max);

        let newurl = window.location.origin + window.location.pathname + $apiURLparam;
        newurl += ((inputLeft.value !== leftmin) || (inputRight.value !== leftmax)) ? `&rangeproperty=${inputLeft.getAttribute('data-id')}:${parseFloat(inputLeft.value)}-TO-${parseFloat(inputRight.value)}` : '';
        let dataPropertyValue = `${inputLeft.getAttribute('data-id')}:${parseFloat(inputLeft.value)}-TO-${parseFloat(inputRight.value)}`;

        $properties.forEach((propertyID) => {
            newurl += propertyID !== '' ? `&property=${propertyID}` : '';
        });
        $rangeproperties.forEach((rangepropertyID) => {
            if (!decodeURIComponent(rangepropertyID).includes(decodeURIComponent(inputLeft.getAttribute('data-id'))) && rangepropertyID !== '') {
                dataPropertyValue += `;${rangepropertyID}`;
                newurl += `&rangeproperty=${rangepropertyID}`;
            }
        });

        $dataIndicationTypeArray.forEach((indicationType) => {
            newurl += indicationType !== '' ? `&propertyType=${indicationType}` : '';
        });

        let newurlFilter = '&contextCategory=';
        $contextCategoryArray.forEach((contextCategoryFilter) => {
            newurlFilter += `${contextCategoryFilter},`;
        });

        if (newurlFilter !== '&contextCategory=') {
            newurl += newurlFilter.slice(0, -1);
        }
        jQuery('#search-results__products').attr('data-rangeproperty', dataPropertyValue);
        window.location.href = newurl.replace(/#/g, '%23');
    }

    function setLeftValue() {
        const multiRangeSlider = this.closest('.multi-range-slider');

        const inputLeft = multiRangeSlider.querySelector('.multi-range-slider__input--left');
        const inputRight = multiRangeSlider.querySelector('.multi-range-slider__input--right');
        const thumbLeft = multiRangeSlider.querySelector('.multi-range-slider__content > .multi-range-slider__thumb--left');
        const range = multiRangeSlider.querySelector('.multi-range-slider__content > .multi-range-slider__range');

        const min = parseInt(inputLeft.min);
        const max = parseInt(inputLeft.max);
        inputLeft.value = Math.min(parseInt(inputLeft.value), parseInt(inputRight.value) - 1);
        const percent = ((inputLeft.value - min) / (max - min)) * 100;
        thumbLeft.style.left = `${percent}%`;
        range.style.left = `${percent}%`;
        multiRangeSlider.querySelector('.left-value').textContent = inputLeft.value;
    }

    function setRightValue() {
        const multiRangeSlider = this.closest('.multi-range-slider');

        const inputLeft = multiRangeSlider.querySelector('.multi-range-slider__input--left');
        const inputRight = multiRangeSlider.querySelector('.multi-range-slider__input--right');
        const thumbRight = multiRangeSlider.querySelector('.multi-range-slider__content > .multi-range-slider__thumb--right');
        const range = multiRangeSlider.querySelector('.multi-range-slider__content > .multi-range-slider__range');

        const min = parseInt(inputRight.min);
        const max = parseInt(inputRight.max);
        inputRight.value = Math.max(parseInt(inputRight.value), parseInt(inputLeft.value) + 1);
        const percent = ((inputRight.value - min) / (max - min)) * 100;
        thumbRight.style.right = `${100 - percent}%`;
        range.style.right = `${100 - percent}%`;
        multiRangeSlider.querySelector('.right-value').textContent = inputRight.value;
    }
}

if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    init();
}
